import React from "react";
import Layout from "./../layout";
import { URLS } from "../../_config";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import ToggleSwitch2 from "../../components/ToggleSwitch2";

import { Tab, Nav, Card, Form, Button, Row, Col } from "react-bootstrap";
const handleToggle2 = (state: boolean) => {
  console.log("Toggle state:", state);
};
const PreOrder: React.FC = () => {
  return (
    <Layout>
      <div data-aos="fade-up" data-aos-duration="1000">
        <Breadcrumbs
          title="Pre Order"
          breadcrumbs={{ Home: URLS.PROFILE, "Pre Order": URLS.PREORDER.LIST }}
        />

        <Tab.Container defaultActiveKey="first">
          <Row>
            <Col sm={3} className="vr-tabs-panel">
              <Nav
                variant="pills"
                className="flex-column nav-pills pre_ordertab mt-3 height_auto"
              >
                <Nav.Item>
                  <Nav.Link eventKey="first">
                    <span className="tabs-number">
                      <img src="assets/images/pre_order/list.png" />
                    </span>
                    All
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">
                    <span className="tabs-number">
                      <img src="assets/images/pre_order/order.png" />
                    </span>{" "}
                    New Order
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">
                    <span className="tabs-number">
                      <img src="assets/images/pre_order/privacy.png" />
                    </span>{" "}
                    On Hold
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="forth">
                    <span className="tabs-number">
                      <img src="assets/images/pre_order/payment (1).png" />
                    </span>{" "}
                    Payment Pending
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="fifth">
                    <span className="tabs-number">
                      <img src="assets/images/pre_order/completed-task.png" />
                    </span>{" "}
                    Paid
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="six">
                    <span className="tabs-number">
                      <img src="assets/images/pre_order/shuttle.png" />
                    </span>{" "}
                    Started
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="seven">
                    <span className="tabs-number">
                      <img src="assets/images/pre_order/completed-task.png" />
                    </span>{" "}
                    Completed
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <div className="d-flex align-items-center ml-4">
                    <div className="custom-control custom-checkbox custom-checkbox-lg  custom-checkbox-primary mb-3">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="customCheckcolor2"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="customCheckcolor2"
                      >
                        Exclude Completed
                      </label>
                    </div>
                  </div>
                </Nav.Item>
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <div
                    className="tab-pane fade show active"
                    id="v-pills-home"
                    role="tabpanel"
                    aria-labelledby="v-pills-home-tab"
                  >
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="p-3">
                          <div className="section-heading d-flex align-items-center justify-content-between pl-2 mb-0">
                            <h2>All</h2>
                            <div className="d-flex gap-15">
                              <div className="off-on-toggle d-flex align-items-center mr-0">
                                <ToggleSwitch2
                                  onlineText2="Active"
                                  offlineText2="Cancel"
                                  onlineColor="#008080"
                                  offlineColor="#333333"
                                  initialState={true}
                                  onToggle={handleToggle2}
                                />
                              </div>
                              <div>
                                <select className="form-control height38">
                                  <option value="">Select Date</option>
                                  <option value="">Last 30 Days</option>
                                </select>
                              </div>
                              <a
                                href="#"
                                className="btn btn-info new_escalationbtn"
                              >
                                <img src="assets/images/pre_order/bell.png" />{" "}
                                Notifications
                              </a>
                              <a
                                href="#"
                                className="btn btn-secondary right-bar-toggle font14"
                              >
                                <img src="assets/images/icons/04.png" /> Filter
                              </a>
                            </div>
                          </div>
                          <div className="table-responsive">
                            <table
                              id="datatable"
                              className="table table-bordered table-striped dt-responsive nowrap"
                            >
                              <thead>
                                <tr>
                                  <th>ID</th>
                                  <th>Order Info</th>
                                  <th>Paid At</th>
                                  <th>Status</th>
                                  <th>Order By</th>
                                  <th>Order Manager</th>
                                  <th>Staff</th>
                                  <th>Last Update</th>
                                  <th>Action</th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr>
                                  <td>#54825</td>
                                  <td>Custom Business Card</td>
                                  <td>N/A</td>
                                  <td>
                                    <span className="badge badge-pill badge-soft-success font-size-12">
                                      Complete
                                    </span>
                                  </td>
                                  <td>William</td>
                                  <td>Benjamin</td>
                                  <td>Henry</td>
                                  <td>
                                    Note: Milestone <br />
                                    Jan 20, 2025
                                  </td>
                                  <td>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/icons/02.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/show.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/cancel.png" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#54826</td>
                                  <td>Custom Business Card</td>
                                  <td>N/A</td>
                                  <td>
                                    <span className="badge badge-pill badge-soft-primary font-size-12">
                                      Approved
                                    </span>
                                  </td>
                                  <td>William</td>
                                  <td>Benjamin</td>
                                  <td>Henry</td>
                                  <td>
                                    Updated(Pending Business <br />
                                    card Selection) <br />
                                    Jan 20, 2025
                                  </td>
                                  <td>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/icons/02.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/show.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/cancel.png" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#54827</td>
                                  <td>Custom Business Card</td>
                                  <td>N/A</td>
                                  <td>
                                    <span className="badge badge-pill badge-soft-warning font-size-12">
                                      Pending
                                    </span>
                                  </td>
                                  <td>William</td>
                                  <td>Benjamin</td>
                                  <td>Henry</td>
                                  <td>
                                    Note: Milestone <br />
                                    Updated(Pending ) <br />
                                    Jan 20, 2025
                                  </td>
                                  <td>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/icons/02.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/show.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/cancel.png" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#54828</td>
                                  <td>Custom Business Card</td>
                                  <td>N/A</td>
                                  <td>
                                    <span className="badge badge-pill badge-soft-primary font-size-12">
                                      Approved
                                    </span>
                                  </td>
                                  <td>William</td>
                                  <td>Benjamin</td>
                                  <td>Henry</td>
                                  <td>
                                    Note: Milestone <br />
                                    Updated(Pending) <br />
                                    Jan 20, 2025
                                  </td>
                                  <td>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/icons/02.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/show.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/cancel.png" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#54829</td>
                                  <td>Custom Business Card</td>
                                  <td>N/A</td>
                                  <td>
                                    <span className="badge badge-pill badge-soft-success font-size-12">
                                      Complete
                                    </span>
                                  </td>
                                  <td>William</td>
                                  <td>Benjamin</td>
                                  <td>Henry</td>
                                  <td>
                                    Note: Milestone <br />
                                    Updated(Pending ) <br />
                                    Jan 20, 2025
                                  </td>
                                  <td>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/icons/02.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/show.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/cancel.png" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#54830</td>
                                  <td>Custom Business Card</td>
                                  <td>N/A</td>
                                  <td>
                                    <span className="badge badge-pill badge-soft-warning font-size-12">
                                      Pending
                                    </span>
                                  </td>
                                  <td>William</td>
                                  <td>Benjamin</td>
                                  <td>Henry</td>
                                  <td>
                                    Note: Milestone <br />
                                    Updated(Pending ) <br />
                                    Jan 20, 2025
                                  </td>
                                  <td>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/icons/02.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/show.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/cancel.png" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#54831</td>
                                  <td>Custom Business Card</td>
                                  <td>N/A</td>
                                  <td>
                                    <span className="badge badge-pill badge-soft-warning font-size-12">
                                      Pending
                                    </span>
                                  </td>
                                  <td>William</td>
                                  <td>Benjamin</td>
                                  <td>Henry</td>
                                  <td>
                                    Note: Milestone <br />
                                    Updated(Pending Business <br />
                                    card Selection) <br />
                                    Jan 20, 2025
                                  </td>
                                  <td>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/icons/02.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/show.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/cancel.png" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#54832</td>
                                  <td>Custom Business Card</td>
                                  <td>N/A</td>
                                  <td>
                                    <span className="badge badge-pill badge-soft-warning font-size-12">
                                      Pending
                                    </span>
                                  </td>
                                  <td>William</td>
                                  <td>Benjamin</td>
                                  <td>Henry</td>
                                  <td>
                                    Note: Milestone <br />
                                    Updated(Pending) <br />
                                    Jan 20, 2025
                                  </td>
                                  <td>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/icons/02.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/show.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/cancel.png" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#54833</td>
                                  <td>Custom Business Card</td>
                                  <td>N/A</td>
                                  <td>
                                    <span className="badge badge-pill badge-soft-warning font-size-12">
                                      Pending
                                    </span>
                                  </td>
                                  <td>William</td>
                                  <td>Benjamin</td>
                                  <td>Henry</td>
                                  <td>
                                    Note: Milestone <br />
                                    Updated(Pending ) <br />
                                    Jan 20, 2025
                                  </td>
                                  <td>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/icons/02.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/show.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/cancel.png" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>#54834</td>
                                  <td>Custom Business Card</td>
                                  <td>N/A</td>
                                  <td>
                                    <span className="badge badge-pill badge-soft-success font-size-12">
                                      Complete
                                    </span>
                                  </td>
                                  <td>William</td>
                                  <td>Benjamin</td>
                                  <td>Henry</td>
                                  <td>
                                    Note: Milestone <br />
                                    Updated(Pending Business <br />
                                    card Selection) <br />
                                    Jan 20, 2025
                                  </td>
                                  <td>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/icons/02.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/show.png" />
                                    </a>
                                    <a className="ml-2" href="#">
                                      <img src="assets/images/pre_order/cancel.png" />
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <div className="card">
                    <div className="card-body">
                      <div className="section-heading">
                        <h2>New Order</h2>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <div className="card">
                    <div className="card-body">
                      <div className="section-heading">
                        <h2>Payment Pending</h2>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="forth">
                  <div className="card">
                    <div className="card-body">
                      <div className="section-heading">
                        <h2>On Hold</h2>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="fifth">
                  <div className="card">
                    <div className="card-body">
                      <div className="section-heading">
                        <h2>Paid</h2>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="six">
                  <div className="card">
                    <div className="card-body">
                      <div className="section-heading">
                        <h2>Started</h2>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="seven">
                  <div className="card">
                    <div className="card-body">
                      <div className="section-heading">
                        <h2>Completed</h2>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    </Layout>
  );
};

export default PreOrder;
